import services from 'services';
const slackURL = '/api/v1/slack-services';
const jenkinsIcon = 'https://www.jenkins.io/images/logos/worldwide/worldwide.png';

const colorCode = {
  STARTED: '#FFFF00',
  SUCCESS: '#00FF00',
  ERROR: '#FF0000',
};

class SlackService {
  sendError({ title, message }) {
    return services.post(slackURL, {
      text: `:pepe-yamero: ${title}`,
      channel: '#system',
      username: 'jenkins',
      icon_url: jenkinsIcon,
      attachments: [{ color: colorCode.ERROR, text: message }],
    });
  }
}

export default new SlackService();
